export const ROUTE_BASE = '/';
